module.exports = __webpack_public_path__ + "img/Roro.72431c9b.svg";